var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6292",
    "data-name": "Group 6292",
    transform: "translate(-2078 514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6284",
    "data-name": "Group 6284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M2,0H16a2,2,0,0,1,2,2V16a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z",
    transform: "translate(2078 -514)",
    fill: "#002340"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5367",
    "data-name": "Rectangle 5367",
    width: 6,
    height: 2,
    transform: "translate(2084 -506)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColapse);
export default __webpack_public_path__ + "static/media/colapse.74a70cec.svg";
export { ForwardRef as ReactComponent };